import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

const screens = {
    lg: 1080, //tailwind.config.js
};

function initialize() {
    const widthWindow = Math.min(document.documentElement.clientWidth, window.innerWidth);

    const desktopOffsetX = (widthWindow - screens.lg) / 2;

    new Swiper('.products-used .swiper', {
        modules: [Navigation, Pagination],

        slidesPerView: 'auto',

        breakpoints: {
            320: {
                slidesOffsetAfter: 32,
                slidesOffsetBefore: 32,
                spaceBetween: 24,
            },
            1080: {
                slidesOffsetBefore: desktopOffsetX,
                slidesOffsetAfter: desktopOffsetX,
                spaceBetween: 32,
            },
        },

        pagination: {
            el: '.products-used .swiper-pagination',
            type: 'bullets',
            clickable: true,
        },

        navigation: {
            prevEl: '.products-used .btn-prev',
            nextEl: '.products-used .btn-next',
        },
    });
}

initialize();
